import {Component, Input, OnChanges, OutputEmitterRef, SimpleChanges, WritableSignal, inject, output, signal} from '@angular/core';
import {BreadcrumbModule} from "@syncfusion/ej2-angular-navigations";
import {IconBadgeComponent} from "../icon-badge/icon-badge.component";
import {RouterService} from "../../services/router.service";
import {TYPE} from "../../types/types";

@Component({
    selector: 'app-breadcrumb',
    imports: [
        BreadcrumbModule,
        IconBadgeComponent
    ],
    templateUrl: './breadcrumb.component.html',
    styleUrl: './breadcrumb.component.scss'
})
export class BreadcrumbComponent implements OnChanges {
  public routerService: RouterService = inject(RouterService);

  @Input() public breadcrumbItems: TYPE.BreadcrumbItem[] = [];
  @Input() public type: 'default' | 'community' | 'no_routing' = 'default';

  public itemClicked: OutputEmitterRef<number | null> = output<number | null>();

  public isVisible: WritableSignal<boolean> = signal(true);

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['breadcrumbItems'] && changes['breadcrumbItems'].currentValue) { // necessary to trigger re-rendering because of Syncfusion's rendering issues
      this.isVisible.set(false);
      setTimeout(() => {
        this.isVisible.set(true);
      }, 0);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public emitNoRoutingItemClicked(event: any): void {
    this.itemClicked.emit(event.item.id !== '' ? parseInt(event.item.id) : null);
  }
}
